import { http } from "Utils/http";
import { Form, Tabs, Tab, Row, Col, Card, Dropdown, Button, Stack } from "react-bootstrap";
import { useState, useEffect } from "react";
import ListOrg from "Containers/Private/Organization/List/ListOrg";
import { useLocation } from 'react-router-dom';
import { STATUSES } from "Utils/constants";
import { store } from 'Store';
import { setGlobalErrorStatus, setGlobalSuccessStatus } from 'Components/StatusHandling'
import { useDispatch } from "react-redux"

import { ERROR_MESSAGES } from "Utils/constants";

const ListOrganization = ({ setBreadcrumbs }) => {

  let location = useLocation();
  var passedData = location.state;

  //console.log("PASSED DATA", passedData, JSON.stringify(passedData));
  useEffect(() => {
    setBreadcrumbs([{ title: "Home", path: "" }, { title: "Background" }]);
  }, [])

  var dispatch = useDispatch();

  const loginState = store.getState().loginInfo;
  //console.log("LISTORGLOGIN", loginState);
  const passedOrgValue = () => {
    if (passedData != null) {
      if (passedData.orgType != null) {
        return passedData.orgType;
      }
      else {
        return 'PSO';
      }
    }
    else {
      return 'PSO';
    }
  }

  const passedStatusValue = () => {
    if (passedData != null) {
      if (passedData.status != null) {
        return passedData.status;
      }
      else {
        return STATUSES.NORMAL;
      }
    }
    else {
      return STATUSES.NORMAL;
    }
  }

  const [status, setStatus] = useState(passedStatusValue());
  const passedOrg = passedOrgValue();
  const isPopupVisible = () => {
    if (passedData != null) {
      if (passedData.modal != null) {
        return true;
      }
    }
    return false;
  }
  const getPopupData = () => {
    if (passedData != null) {
      if (passedData.modal != null) {
        return passedData.modal;
      }
      else {
        return { title: "", msg: "" };
      }
    }
    else {
      return { title: "", msg: "" };
    }
  }
  // Popup
  const [showPopup, setShowPopup] = useState(isPopupVisible());
  const [popupMsg, setPopMsg] = useState(getPopupData())

  const [isPSOAdmin, setIsPSOAdmin] = useState(false);
  const [isPSOPPCAdmin, setIsPSOPPCAdmin] = useState(false);
  const [allowEdit, setAllowEdit] = useState(false);
  const [orgType, setOrgType] = useState(passedOrg);
  const [isLoading, setIsLoading] = useState(false)

  const [tab, setTab] = useState(passedOrg);

  const handleTabChange = (e) => {
    setTab(e);
    setOrgType(e);
  }
  //console.log(loginState.token);

  const getOrgAccessData = async () => {
    setIsLoading(true);
    const res = await http.post('/api/manage/' + orgType + '', null, {
      headers: {
        //"Authorization": "Bearer " + loginInfo.token
        "Authorization": "Bearer " + loginState.token
        //"Referrer-Policy": "strict-origin-when-cross-origin"
      }
    }).then(res => {

      //console.log("statuses", res);
      let statusCode = res.status;
      if (statusCode < 0) {
        statusCode = STATUSES.ERROR.code;
      }

      if (statusCode == 1) {
        //console.log("getOrgAccessData ", res.data);
        var d = res.data;
        setIsPSOPPCAdmin(d.isPSOPPCAdmin);
        setIsPSOAdmin(d.isPSOAdmin);
        setAllowEdit(d.allow_edit);
      }
      else {
        if (res.globalErrorMessageList && res.globalErrorMessageList.length != 0) {
          setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
              visible: true,
              title: ERROR_MESSAGES.DATA_ERROR.title,
              msg: res.globalErrorMessageList,
              showContactHelp: true
            },
            redirect: {
              redirect: false,
              redirectFirst: false,
              path: "",
              data: {}
            }
          });
        }
      }
    }).catch(function (error) {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.GENERAL_ERROR.title,
          msg: ERROR_MESSAGES.GENERAL_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error:error
      });
      //console.log("error caught from getOrgAccessData()", error);
      //alert("error caught from loadCompletedPSETestBatches()");
      //setIsCompletedPSETestBatchPending(false);
      //if (!showPopup) {
      //setShowPopup(true);
      //setPopMsg({
      //title: "Data Error",
      //msg: "At this time, we are experiencing problems retrieving the data."
      //});
      //}

    });
  };

  useEffect(() => {
    setIsLoading(true);
    getOrgAccessData().then(() => {
      setIsLoading(false);
    })
  }, [orgType]);

  return (
    <Row>
      <Row >
        <Col xl={11} lg={11} md={11} sm={12}>
          <Card className="p-4" >
            {isPSOPPCAdmin == true || isPSOAdmin == true
              ?
              <Card.Body className="text-start">
                <h1 id="mainContent" className="header1 text-start mb-3 blue bold">Manage Organizations</h1>
                <Row>
                  <Form>

                    <Row>
                      <p>Click on the organization type tabs below to view each of the organization type tables.</p>
                    </Row>
                    <Row>
                      <Col>
                        <Tabs
                            id="organizationTabs"
                            activeKey={tab}
                            onSelect={(k) => handleTabChange(k)}
                            mountOnEnter={true}
                            unmountOnExit={true}
                        >
                          <Tab eventKey="PSO" title="PSO" >
                            {tab === "PSO" && isPSOPPCAdmin == true ?
                              <ListOrg orgType="PSO" info={{ allowEdit: allowEdit, isPSOPPCAdmin: isPSOPPCAdmin, isPSOAdmin: isPSOAdmin, isLoading: isLoading }} />
                              : ""}
                          </Tab>
                          <Tab eventKey="Admin" title="Admin" >
                            {tab === "Admin" && isPSOPPCAdmin == true ?
                              <ListOrg orgType="Admin" info={{ allowEdit: allowEdit, isPSOPPCAdmin: isPSOPPCAdmin, isPSOAdmin: isPSOAdmin, isLoading: isLoading }} />
                              : ""}
                          </Tab>
                          <Tab eventKey="Vendor" title="Vendor" >
                            {tab === "Vendor" && (isPSOPPCAdmin == true || isPSOAdmin == false) ?
                              <ListOrg orgType="Vendor" info={{ allowEdit: allowEdit, isPSOPPCAdmin: isPSOPPCAdmin, isPSOAdmin: isPSOAdmin, isLoading: isLoading }} />
                              : ""}
                          </Tab>
                        </Tabs>
                      </Col>
                    </Row>
                  </Form>
                </Row>
              </Card.Body>
              : null
            }
          </Card>
        </Col>
      </Row>
    </Row>
  )
}

export default ListOrganization;